import { type UiLibI18n } from '@myre/domain-i18n-wordings';
import { wordingKeyEcho } from '@myre/ui-primitive-core';

import { InjectionToken } from '@angular/core';

/**
 * The wordings ui-primitive-multi-table reads. A frontend provides them from
 * the wordings it loaded, which type-checks them against the generated tree;
 * without one, each leaf answers its own key.
 */
export interface PrimitiveMultiTableWordings {
  _library: {
    message: {
      formList: Pick<
        UiLibI18n['message']['formList'],
        'totalNoElements' | 'totalOneElement' | 'totalSeveralElements'
      >;
    };
    table: Pick<UiLibI18n['table'], 'noData' | 'noDataFiltered'>;
  };
}

export const PRIMITIVE_MULTI_TABLE_WORDINGS =
  new InjectionToken<PrimitiveMultiTableWordings>(
    'PrimitiveMultiTableWordings',
    {
      providedIn: 'root',
      factory: () => wordingKeyEcho<PrimitiveMultiTableWordings>(),
    },
  );
